export default __webpack_public_path__ + "static/media/algodao_v2.7a219bc6.png";